import React from "react";
import "../../Assets/css/footer.css";
import FooterVenice from "../Front/themes/venice/Footer/FooterVenice";

const Footer = () => {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <FooterVenice />
  );
};
export default Footer;
